import React from 'react';
import { Delete, IconButton } from '@tds/core-interactive-icon';
import FlexGrid from '@tds/core-flex-grid';
import PropTypes from 'prop-types';

import { RowBordered, Bold, FullWidth, TopRight } from '../css';

const AddedItemsList = ({ addedItems, onAddedItemDelete }) => {
  return (
    <FlexGrid>
      <FlexGrid.Row>
        {addedItems.map((addedItem, addedItemIndex) => (
          <RowBordered key={addedItem.key}>
            <FullWidth>
              <TopRight>
                <IconButton
                  onClick={() => onAddedItemDelete(addedItemIndex)}
                  copy="en"
                  icon={Delete}
                />
              </TopRight>
              <FlexGrid.Row>
                {Object.keys(addedItem).map(
                  key =>
                    key !== 'ovLines' &&
                    key !== 'key' && (
                      <FlexGrid.Col
                        xs={12}
                        md={6}
                        key={`addedLineField-${key}`}
                      >
                        <Bold>{addedItem[key].label}</Bold> :{' '}
                        {addedItem[key].value}
                        <br />
                      </FlexGrid.Col>
                    )
                )}
              </FlexGrid.Row>
            </FullWidth>
            {addedItem.ovLines.map(ovLine => (
              <FullWidth key={ovLine.key}>
                <RowBordered>
                  <div>
                    <FlexGrid.Row>
                      {Object.keys(ovLine).map(
                        key =>
                          key !== 'ovLines' &&
                          key !== 'key' && (
                            <FlexGrid.Col
                              xs={12}
                              md={6}
                              key={`addedOvLineField-${key}`}
                            >
                              <Bold>{ovLine[key].label}</Bold> :{' '}
                              {ovLine[key].value}
                              <br />
                            </FlexGrid.Col>
                          )
                      )}
                    </FlexGrid.Row>
                  </div>
                </RowBordered>
              </FullWidth>
            ))}
          </RowBordered>
        ))}
      </FlexGrid.Row>
    </FlexGrid>
  );
};

AddedItemsList.propTypes = {
  addedItems: PropTypes.arrayOf(PropTypes.any).isRequired,
  onAddedItemDelete: PropTypes.func.isRequired
};

export default AddedItemsList;
